export const MIN_ACCOUNT_CODE = 100000;
export const MAX_ACCOUNT_CODE = 999999;

export const MIN_CUSTOM_ACCOUNT_CODE = 1;
export const MAX_CUSTOM_ACCOUNT_CODE = 999999999;

export const MIN_TEMPORARY_ACCOUNT_CODE = MAX_CUSTOM_ACCOUNT_CODE + 1;

export function isAccountCodeWithinGlobalBounds(code: number): boolean {
    return (
        Number.isInteger(code) &&
        code >= MIN_CUSTOM_ACCOUNT_CODE &&
        code <= MAX_CUSTOM_ACCOUNT_CODE
    );
}
